// src/hooks/programs/useDeleteAllPrograms.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteAllPrograms } from "../../api/apiPrograms";
import parseError from "../../utils/parseError";

const useDeleteAllPrograms = () => {
    const queryClient = useQueryClient();

    const {
        mutate: deleteAllProgramsMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: deleteAllPrograms,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["programs"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete programs");
        },
    });

    return {
        deleteAllProgramsMutate,
        isPending: isPending || isLoading,
    };
};

export default useDeleteAllPrograms;
